export default __webpack_public_path__ + "static/media/aprove.2cb8e02f.svg";